import { config } from "@/config";
export const RepuestoService = {
    async getRepuestoById(id) {
        const response = await fetch(`${config.API_URL}/api/Repuesto/${id}`, {
            method: "GET",
        });
        if (!response.ok) {
            throw new Error(`Error al obtener el repuesto con id ${id}`);
        }
        const data = await response.json();
        return data;
    },
    async getAllRepuestos(search = "") {
        const url = new URL(`${config.API_URL}/api/Repuesto`);
        if (search)
            url.searchParams.append("search", search);
        const response = await fetch(url.toString(), {
            method: "GET",
        });
        if (!response.ok) {
            throw new Error("Error al obtener todos los repuestos");
        }
        const result = await response.json();
        if (!result.datos || !Array.isArray(result.datos)) {
            console.error('Se esperaba un array de repuestos en la propiedad "datos" pero se recibió:', result);
            return []; // Devuelve un array vacío en caso de error
        }
        return result.datos;
    },
    async getLookup() {
        const response = await fetch(`${config.API_URL}/api/Repuesto/lookup`, {
            method: "GET",
        });
        if (!response.ok) {
            throw new Error("Error al obtener el lookup de repuestos");
        }
        const result = await response.json();
        return result.datos || [];
    },
    async getPaginatedRepuestos(page = 1, search = "", letter = "", departamentoId = null, categoriaId = null) {
        const params = new URLSearchParams();
        if (page)
            params.append("page", page.toString());
        if (search)
            params.append("search", search);
        if (letter)
            params.append("letter", letter);
        if (departamentoId)
            params.append("departamentoId", departamentoId.toString());
        if (categoriaId)
            params.append("categoriaId", categoriaId.toString());
        const response = await fetch(`${config.API_URL}/api/Repuesto/paginated?${params.toString()}`, {
            method: "GET",
        });
        if (!response.ok) {
            throw new Error("Error al obtener repuestos paginados");
        }
        const result = await response.json();
        return result.datos;
    },
    async addRepuesto(repuesto) {
        const response = await fetch(`${config.API_URL}/api/Repuesto`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(repuesto),
        });
        if (!response.ok) {
            let errorMessage = "Error al agregar el repuesto";
            try {
                const errorData = await response.json();
                errorMessage = errorData.message || errorMessage;
            }
            catch (_) {
                // Si no es JSON, queda mensaje por defecto
            }
            throw new Error(errorMessage);
        }
    },
    async addRepuestoBulk(data) {
        const response = await fetch(`${config.API_URL}/api/Repuesto/bulk`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) {
            let errorMessage = "Error al agregar repuestos en bulk";
            try {
                const errorData = await response.json();
                errorMessage = errorData.message || errorMessage;
            }
            catch (_) {
                // Fallback al mensaje por defecto
            }
            throw new Error(errorMessage);
        }
    },
    async updateRepuesto(id, repuesto) {
        const response = await fetch(`${config.API_URL}/api/Repuesto/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(repuesto),
        });
        if (!response.ok) {
            throw new Error("Error al actualizar el repuesto");
        }
    },
    async deleteRepuesto(id) {
        const response = await fetch(`${config.API_URL}/api/Repuesto/${id}`, {
            method: "DELETE",
        });
        if (!response.ok) {
            let errorMessage = "Error al eliminar el repuesto";
            try {
                const errorData = await response.json();
                errorMessage = errorData.message || errorMessage;
            }
            catch (_) { }
            throw new Error(errorMessage);
        }
    },
    async toggleActivo(id) {
        const response = await fetch(`${config.API_URL}/api/Repuesto/${id}/toggle-activo`, {
            method: "PUT",
        });
        if (!response.ok) {
            throw new Error(`Error al cambiar el estado del repuesto con id ${id}`);
        }
        return await response.json();
    },
    // **Nueva función para obtener los atributos desplegables**
    async getAtributosDesplegablesByRepuestoId(id) {
        const response = await fetch(`${config.API_URL}/api/Repuesto/${id}/atributos-desplegables`, {
            method: "GET",
        });
        if (!response.ok) {
            throw new Error(`Error al obtener los atributos desplegables del repuesto con id ${id}`);
        }
        const result = await response.json();
        if (!result.datos || !Array.isArray(result.datos)) {
            console.error('Se esperaba un array de atributos en la propiedad "datos" pero se recibió:', result);
            return []; // Devuelve un array vacío en caso de error
        }
        return result.datos;
    },
    async exportReport(request) {
        const url = new URL(`${config.API_URL}/api/Repuesto/export`);
        if (request.search)
            url.searchParams.append("search", request.search);
        if (request.letter)
            url.searchParams.append("letter", request.letter);
        if (request.departamentoId)
            url.searchParams.append("departamentoId", request.departamentoId.toString());
        if (request.categoriaId)
            url.searchParams.append("categoriaId", request.categoriaId.toString());
        if (request.sortColumn)
            url.searchParams.append("sortColumn", request.sortColumn);
        if (request.sortDirection)
            url.searchParams.append("sortDirection", request.sortDirection);
        url.searchParams.append("format", request.format);
        request.selectedColumns.forEach((col) => {
            url.searchParams.append("selectedColumns", col);
        });
        const response = await fetch(url.toString(), {
            method: "GET",
        });
        if (!response.ok) {
            throw new Error("Error al generar el reporte");
        }
        return await response.blob();
    },
};
